module.exports = __webpack_public_path__ + "static/img/19.45ea23d0.png";